import React from "react";
import { useTranslation } from "react-i18next";
import ListGroup from "@cc/react-components/ListGroup";
import { Col, Row } from "@cc/react-components/Grid";

export interface Props extends React.ButtonHTMLAttributes<HTMLElement> {
  /**
   * The index of the item that will be selected by default.
   * If no defaultIndex is provided nothing will be selected.
   *
   */
  numberOfPatients: number;
  /**
   * A callback hook for when the selected element is changed.
   *
   */
  setNumberOfPatients(index: number): void;
}

const NumberOfPatients = ({ numberOfPatients, setNumberOfPatients }: Props) => {
  const [t] = useTranslation();
  return (
    <Row>
      <Col className="my-auto">
        <h3 className="mb-0">{t("amountOfPatients.title")}</h3>
      </Col>
      <Col>
        <ListGroup horizontal>
          {[1, 2, 3].map((value) => (
            <ListGroup.Item
              key={value}
              active={numberOfPatients === value}
              onClick={() => setNumberOfPatients(value)}
              className="text-center"
            >
              {value}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>
    </Row>
  );
};

export default NumberOfPatients;
